<template>
  <div>
    <base-header class="pb-6 pb-8 pt-3 pt-md-7">
      <!-- Card stats -->
      <b-row>
        <b-col xl="3" md="6">
          <!-- <FacturacionSaldoTimbres/> -->
        </b-col>
      </b-row>
    </base-header>

    <!--Charts-->
    <b-container fluid class="mt--8">
      <b-row>
        <b-col md="12">
          <h1 class="text-center text-light">Bienvenido !</h1>
        </b-col>
        <!-- <b-col md="6">
          <b-card title="CORTES DEL DÍA" class="shadow">
            <table class="table table-hover table-sm">
              <thead class="bg-light">
                <tr>
                  <th>Folio</th>
                  <th>Fecha</th>
                  <th>Sucursal</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>30/03/2021</td>
                  <td>LA CALMA</td>
                  <td>
                    <b-badge variant="warning">En Espera</b-badge>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-card>
        </b-col> -->
      </b-row>
    </b-container>
  </div>
</template>
<script>
import FacturacionSaldoTimbres from "./../components/IDBRICS/FacturacionSaldoTimbres.vue";
export default {
  components: {
    FacturacionSaldoTimbres,
  },
  data() {
    return {
      working: false,
      pedidos: [],
    };
  },
  beforeMount() {
    this.getPedidos();
  },
  methods: {
    getPedidos() {
      this.$api.get("pedidos").then((res) => {
        this.pedidos = res.data;
      });
    },
    recibirPedido(pedido) {
      this.$api
        .post(`pedidos/${pedido.id}`)
        .then((res) => {
          console.log(res.data);
        })
        .catch((e) => console.log(e));
    },
  },
};
</script>
<style>
.el-table .cell {
  padding-left: 0px;
  padding-right: 0px;
}
</style>
